export class ScheduleCalculatorBusyError extends Error {
    constructor(message?: string) {
        super(
            `${message ?? 'Schedule calculation is already in progress. Concurrent calculations are not supported.'}`
        );
        this.name = 'ScheduleCalculatorBusyError';
    }
}

export class InvalidStartDateTimeError extends Error {
    scheduleItemIndex?: number;
    constructor(message?: string, index?: number) {
        super(`${message ?? 'Invalid schedule start date/time'}${index !== undefined ? ` at index ${index}` : ''}`);
        this.name = 'InvalidStartDateTimeError';
        this.scheduleItemIndex = index;
    }
}

export class InvalidDurationUnitError extends Error {
    scheduleItemIndex?: number;
    durationUnit?: string;
    constructor(message?: string, index?: number, durationUnit?: string) {
        super(
            `${message ?? 'Invalid schedule duration unit'}${durationUnit ? `: ${durationUnit}` : ''}${index !== undefined ? ` at index ${index}` : ''}`
        );
        this.name = 'InvalidDurationUnitError';
        this.scheduleItemIndex = index;
        this.durationUnit = durationUnit;
    }
}

export class DurationValueRequiredError extends Error {
    scheduleItemIndex?: number;
    constructor(message?: string, index?: number) {
        super(`${message ?? 'Schedule duration value is missing'}${index !== undefined ? ` at index ${index}` : ''}`);
        this.name = 'DurationValueRequiredError';
        this.scheduleItemIndex = index;
    }
}

export class EndDateRequiredError extends Error {
    scheduleItemIndex?: number;
    constructor(message?: string, index?: number) {
        super(`${message ?? 'Schedule end date is missing'}${index !== undefined ? ` at index ${index}` : ''}`);
        this.name = 'EndDateRequiredError';
        this.scheduleItemIndex = index;
    }
}

export class InvalidDateTimeRangeError extends Error {
    scheduleItemIndex?: number;
    constructor(message?: string, index?: number) {
        super(
            `${message ?? 'Invalid schedule date/time range. Start date/time must be before end date/time'}${index !== undefined ? ` at index ${index}` : ''}`
        );
        this.name = 'InvalidDateTimeRangeError';
        this.scheduleItemIndex = index;
    }
}

export class InvalidChildDateTimeError extends Error {
    scheduleItemIndex?: number;
    constructor(message?: string, index?: number) {
        super(`${message ?? 'Invalid child schedule date/time'}${index !== undefined ? ` at index ${index}` : ''}`);
        this.name = 'InvalidChildDateTimeError';
        this.scheduleItemIndex = index;
    }
}

export class ScheduleCalculationFailedError extends Error {
    scheduleItemIndex?: number;
    constructor(message?: string, index?: number) {
        super(`${message || 'Failed to calculate schedule'}${index !== undefined ? ` at index ${index}` : ''}`);
        this.name = 'ScheduleCalculationFailedError';
        this.scheduleItemIndex = index;
    }
}

export class MixedDurationSpecifiedError extends Error {
    scheduleItemIndex?: number;
    constructor(message?: string, index?: number) {
        super(
            `${
                message || 'Schedule list item does not have the same "duration specified" setting as others'
            }${index !== undefined ? ` at index ${index}` : ''}`
        );
        this.name = 'MixedDurationSpecifiedError';
        this.scheduleItemIndex = index;
    }
}
